import { VStack } from "@chakra-ui/react"
import React from "react"
import { GenerateUserDetailsReportForm } from "../../../forms"

export const GenerateUserDetailsReport: React.FC = () => {
	return (
		<VStack w="full" spacing={6}>
			<GenerateUserDetailsReportForm />
		</VStack>
	)
}
